import React from 'react';
import type { PropsWithChildren } from 'react';

import { CardActionArea } from '@mui/material';

import Link from 'src/components/ui/Link';

import type { Ad } from 'src/types/__generated__/graphql';
import { routePathAd } from 'src/constants/router';

export type PropertyCardLinkProps = PropsWithChildren<{
    ad: Pick<Ad, 'id' | 'status'>;
    buildAdHref?: (ad: Pick<Ad, 'id'>) => string;
    dataTargetId?: string;
}>;
export const defaultAdHref = ({ id }: Pick<Ad, 'id'>) => `${routePathAd}/${id}`;

const PropertyCardLink: React.FC<PropertyCardLinkProps> = ({
    children,
    ad,
    buildAdHref = defaultAdHref,
    dataTargetId,
}: PropertyCardLinkProps): JSX.Element | null =>
    ad.id && (ad.status === 'available' || ad.status === 'ended') ? (
        <CardActionArea LinkComponent={Link} href={buildAdHref(ad)} data-target-id={dataTargetId} disableRipple>
            {children}
        </CardActionArea>
    ) : (
        // eslint-disable-next-line react/jsx-no-useless-fragment -- needed to satisfy React.FC
        <>{children}</>
    );

export default PropertyCardLink;
